import React from "react";

const RuleTableHead = ({
  columnSearch = {},
  setColumnSearch = () => {},
  setIsSearching = () => {},
  onColumnFiltersChange = () => {},
}) => {
  const columns = [
    "ruleId",
    "ruleName",
    "description",
    "dqDimension",
    "keywords",
    "checkType",
    "rulePhase",
    "category",
    "threshold",
    "remediationAction",
    "owner",
    "status",
  ];

  const columnLabels = {
    ruleId: "Rule ID",
    ruleName: "Rule Name",
    description: "Description",
    dqDimension: "DQ Dimension",
    keywords: "Keywords",
    checkType: "Check Type",
    rulePhase: "Rule Phase",
    category: "Category",
    threshold: "Tolerable Error Limit",
    remediationAction: "Remediation Action",
    owner: "Owner",
    status: "Status",
  };

  return (
    <thead>
      <tr>
        {columns.map((col) => (
          <th
            key={col}
            className="text-left pb-0"
            style={{ fontSize: "10px", textTransform: "none" }}
          >
            {columnLabels[col]}
          </th>
        ))}
      </tr>

      <tr>
        {columns.map((col) => (
          <th key={col}>
            <input
              className="text-[9px] placeholder-gray-400 rounded pl-2 py-2 w-full outline-none border-none"
              placeholder="Search"
              value={columnSearch[col] || ""}
              onChange={(e) => {
                const value = e.target.value;
                setColumnSearch({ ...columnSearch, [col]: value });
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setIsSearching(true);
                  onColumnFiltersChange(columnSearch);
                  setTimeout(() => setIsSearching(false), 800);
                }
              }}
            />
          </th>
        ))}
      </tr>
    </thead>
  );
};

export default RuleTableHead;
